import { createFileRoute } from '@tanstack/react-router';

import {
  loadSimulationMessages,
  loadSimulationScreens,
  personalCreditSearch,
  simulationPersonalCreditScreen,
} from '@/modules/simulation/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Crédito pessoal no caminho do legado (`router.tsx:1125-1133`, `?simulationMode=fgts` filtra o FGTS), em etapas
// (`?passo=`, W06): a flag e a permissão vão no manifesto. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/ccb/contratar/credito-pessoal/')({
  validateSearch: personalCreditSearch,
  staticData: { screen: simulationPersonalCreditScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationScreens, 'PersonalCreditRouteScreen'),
});
